/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2020 soho team All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2021/1/18 9:52</li>
 * <li>@author     : ____′↘TangSheng</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import request from '../kernel/request'

export default {
    list(params) {
        return request.get('graduate/base', params)
    },
    save(data) {
        return request.post(`graduate/base`, data)
    },
    load(id) {
        return request.get('graduate/base/' + id)
    },
    userDel(id){
        return request.delete('graduate/user/' + id)
    },
    baseDel(id){
        return request.delete('graduate/base/' + id)
    },
    diplomaDel(id){
        return request.delete('graduate/diploma/' + id)
    },
    familyDel(id){
        return request.delete('graduate/family/' + id)
    },
    baseSave(params = {}) {
        if (params.id) {
            return request.put('graduate/base', params);
        }
        return request.post('graduate/base', params);
    },
    userSave(params = {}) {
        if (params.id) {
            return request.put('graduate/user', params);
        }
        return request.post('graduate/user', params);
    },
    diplomaSave(params = {}) {
        if (params.id) {
            return request.put('graduate/diploma', params);
        }
        return request.post('graduate/diploma', params);
    },
    familySave(params = {}) {
        if (params.id) {
            return request.put('graduate/family', params);
        }
        return request.post('graduate/family', params);
    },
}